import { useState } from "react";
import { toast } from "sonner";
import { Check, RotateCcw } from "lucide-react";
import CartToastFrame from "./CartToastFrame";

type CartUndoToastProps = {
  itemName: string;
  toastId: string | number;
  onUndo: () => void;
};

export default function CartUndoToast({
  itemName,
  toastId,
  onUndo,
}: CartUndoToastProps) {
  const [undone, setUndone] = useState(false);

  const handleClick = () => {
    if (undone) return;
    setUndone(true);
    onUndo();
    setTimeout(() => toast.dismiss(toastId), 1500);
  };

  return (
    <CartToastFrame
      desktopContent={
        undone
          ? `${itemName} added to cart.`
          : `${itemName} removed from cart. Undo?`
      }
      mobileContent={
        undone ? `${itemName} added.` : `${itemName} removed. Undo?`
      }
      icon={
        undone ? (
          <Check className="size-4 shrink-0 text-[#1f2022]" />
        ) : (
          <RotateCcw className="size-4 shrink-0 text-[#1f2022]" />
        )
      }
      onClick={handleClick}
      isActive={undone}
      ariaLabel={
        undone ? `${itemName} added to cart` : `Undo removing ${itemName}`
      }
    />
  );
}
